import { TextAreaProps } from 'antd/es/input';
import { ContainerTextArea } from './styles';
import { Input } from 'antd';

const { TextArea } = Input;

export const ATextArea: React.FC<TextAreaProps> = ({ ...res }) => {
  return (
    <ContainerTextArea>
      <TextArea {...res} />
    </ContainerTextArea>
  );
};
